// Keep the agent guidance and API enforcement on the same contact rules.
export type WatiChoice = 'yes' | 'mistake' | 'odia' | 'english' | 'whatsapp' | 'book' | 'call' | 'explore';

export function watiChoice(value: string): WatiChoice | '' {
  const choice = value.trim().normalize('NFC').toLowerCase().replace(/\s+/g, ' ');
  const choices: Record<string, WatiChoice> = {
    'yes': 'yes', 'yes / ହଁ': 'yes',
    'mistake': 'mistake', 'mistake / ଭୁଲ୍': 'mistake',
    'not_mine': 'mistake', 'not mine': 'mistake', 'not mine / ମୋର ନୁହେଁ': 'mistake',
    'explore': 'explore', 'explore / ଦେଖନ୍ତୁ': 'explore', 'just exploring': 'explore',
    'odia': 'odia', 'odia / ଓଡ଼ିଆ': 'odia', 'english': 'english',
    'whatsapp': 'whatsapp', 'whatsapp / ହ୍ୱାଟସଆପ୍': 'whatsapp',
    'whatsapp / ଚାଟ୍': 'whatsapp',
    'ask': 'whatsapp', 'ask / ପଚାରନ୍ତୁ': 'whatsapp',
    'book': 'book', 'book / ବୁକ୍': 'book',
    'call': 'call', 'call_me': 'call', 'call me': 'call', 'call me / କଲ୍': 'call',
  };
  return choices[choice] || '';
}

export function leadContactPolicy(lead: { raw_answers?: unknown; status?: unknown } | null | undefined) {
  let answers: Record<string, unknown> = {};
  try {
    const parsed = typeof lead?.raw_answers === 'string' ? JSON.parse(lead.raw_answers) : lead?.raw_answers;
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) answers = parsed;
  } catch { /* Legacy leads may have no structured answers. */ }
  const state = String(answers.wati_chatbot_state || '');
  const optedOut = answers.do_not_contact === true || state === 'invalid_lead' || lead?.status === 'invalid_lead';
  const preference = String(answers.contact_preference || answers.wati_contact_preference || '');
  const noCall = optedOut || answers.do_not_call === true || ['whatsapp', 'explore', 'book'].includes(preference)
    || (['wati_chatbot_pending', 'wati_chatbot_verified'].includes(state) && preference !== 'call');
  const guidance = optedOut
    ? answers.rejection_reason === 'not_requested'
      ? 'Not requested — do not call or message. The original source is retained.'
      : 'Enquiry rejected — do not call or message. Review the recorded reason.'
    : noCall
      ? preference === 'book'
        ? 'Booking requested — continue in chat. Call only after an explicit callback request.'
        : 'Continue in WhatsApp. Call only after an explicit callback request.'
      : '';
  return { callAllowed: !noCall, messageAllowed: !optedOut, guidance };
}
